const Label = ({ season, label, t }) => {
  const isMMI = season === "mmi";

  return (
    <>
      {season !== "open_reh" && season !== "event" && (
        <div className={`event_label${isMMI ? " mmi_label" : ""}`}>
          <div className="event_label_inner">
            {isMMI && (
              <span className="mmi_badge_season_kicker">
                {t("concerts.season_tag")}
              </span>
            )}
            <h6 className="text-capitalize">{t(`concerts.${label}`)}</h6>
          </div>
        </div>
      )}
    </>
  );
};

export default Label;
